/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  {
    url: "/orders",
    name: "Neue Bestellungen",
    slug: "orders",
    icon: "AlertCircleIcon",
  },
  {
    url: "/sent-orders",
    name: "Bereits versandt",
    slug: "sent-orders",
    icon: "TruckIcon",
  },
  /*   {
    url: "/errors",
    name: "Fehlerüberprüfung",
    slug: "errors",
    icon: "EyeIcon"
  }, */
  {
    url: "/contact-forms",
    name: "Nachrichten Kunden",
    slug: "contact-forms",
    icon: "MessageCircleIcon",
  },
  {
    url: "/delivery-time",
    name: "Lieferzeit",
    slug: "delivery-time",
    icon: "ClockIcon",
  },
  {
    url: "/analysis",
    name: "Analyse",
    slug: "analysis",
    icon: "BarChartIcon",
    requiredRole: "superadmin",
  },
  {
    url: "/prices",
    name: "Preise verwalten",
    slug: "prices",
    icon: "DollarSignIcon",
    requiredRole: "superadmin",
  },
];
